import "./style.scss";
import { FC } from "react";
import { motion } from "framer-motion";

interface Reason { code: string; name: string; description: string; }
interface Props { badReasons?: Reason[]; goodReasons?: Reason[]; }

const TrustfullReasonList: FC<Props> = ({ goodReasons, badReasons }) => {
  const reasonVariants = { hidden: { opacity: 0, scale: 0.98 }, visible: { opacity: 1, scale: 1 } };

  return (
    <div className="reason-container mb-1">
      {goodReasons && goodReasons.length > 0 && (
        <motion.div className="reason-card good" initial="hidden" animate="visible" variants={reasonVariants} transition={{ duration: 0.25 }}>
          <div className="reason-title tag tag-info">Cohérents</div>
          <ul className="reason-list">
            {goodReasons.map((r, i) => (
              <motion.li key={i} initial="hidden" animate="visible" variants={reasonVariants} transition={{ duration: 0.25, delay: 0.04 * i }}>
                <span className="reason-number">{i + 1}.</span> {r.description}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      )}

      {badReasons && badReasons.length > 0 && (
        <motion.div className="reason-card bad" initial="hidden" animate="visible" variants={reasonVariants} transition={{ duration: 0.25 }}>
          <div className="reason-title tag tag-error">Incohérents</div>
          <ul className="reason-list">
            {badReasons.map((r, i) => (
              <motion.li key={i} initial="hidden" animate="visible" variants={reasonVariants} transition={{ duration: 0.25, delay: 0.04 * i }}>
                <span className="reason-number">{i + 1}.</span> {r.description}
              </motion.li>
            ))}
          </ul>
        </motion.div>
      )}
    </div>
  );
};

export default TrustfullReasonList;
